/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { useEffect ,useState} from 'react'
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import treeExample from "../images/treeExample.png";
import tree1 from "../images/tree1.jpg";
import tree2 from "../images/tree2.jpg";
import tree3 from "../images/tree3.jpg";
import rules from "../images/rules1.jpg";
import rulesTree from "../images/rules_tree.jpg";
import forest from "../images/forest.jpg";
import {CardHeader, Checkbox, ListItemIcon} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Popup from "reactjs-popup";
import Link from "@material-ui/core/Link";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";

const styles = {
    root:{
        width:"30%"
    },
    card: {
        backgroundColor:"#e7e7e7",
        minWidth: 200,
        width: "30%",
        margin: 20,
        maxWidth: 400
    },
    media: {
        height: 140
    },
    buttonSelect: {
        fontSize: "16px",
        color: "#4caf50",
        width: "50%"
    },
    buttonInfo: {
        fontSize: "16px",
        color: "#687aff",
        width: "50%"
    },
    buttonConfiguration: {
        fontSize: "16px",
        color: "#e9bb06",
        width: "50%"
    },
    buttonDelete: {
        fontSize: "16px",
        color: "#ff3d00",
        width: "50%"
    }
};

function AlgorithmCard(props) {
    const { classes } = props;
    const [checked, setChecked] = useState(props.checked);

    function handleAlgorithmChange() {
            if (checked) {
                setChecked( false)
            } else {
                setChecked(  true)
            }
            props.handleAlgorithmClick(props.algorithm,!checked)
    }
    useEffect(() => {
            setChecked( props.checked)
        });
    return(
        <Card className={classes.card}>
            <CardActionArea className={props.algorithm} disabled>
                    <CardMedia
                        className={classes.media}
                        image={props.algorithm==="J48" ? tree1:
                            props.algorithm === "RandomTree" ? tree2:
                        props.algorithm ==="REPTree"? tree3:
                        props.algorithm === "FURIA" ? rules:
                        props.algorithm === "FuzzyHoeffdingDecisionTree" ? rulesTree:
                        props.algorithm === "RandomForest" ? forest : treeExample}
                        title={props.algorithm}
                    />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {props.algorithm}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={handleAlgorithmChange}
                            value="checked"
                            color="primary"
                        />
                    }
                    label={props.language.labels[props.language.id].select.toUpperCase()}

                />
                {(props.algorithm === "J48" ||
                    props.algorithm === "RandomTree" ||
                    props.algorithm === "REPTree" ||
                    props.algorithm === "FURIA" ||
                    props.algorithm === "FuzzyHoeffdingDecisionTree" ||
                    props.algorithm === "RandomForest") && (
                    <Popup trigger={
                        <Button
                            id={props.algorithm}
                            size="small"
                            color="primary"
                            className={classes.buttonInfo}
                        >
                            {props.showConfig ? props.language.labels[props.language.id].info
                                : props.language.labels[props.language.id].information }
                        </Button>} modal >
                        <Card >
                            <CardHeader title={props.algorithm} />
                            <CardMedia style ={{height:"300px"}}
                                className={classes.media}
                                image={props.algorithm ==="J48" ? tree1:
                                    props.algorithm ==="RandomTree" ? tree2:
                                        props.algorithm === "REPTree" ? tree3:
                                            props.algorithm === "FURIA" ? rules:
                                                props.algorithm === "FuzzyHoeffdingDecisionTree" ? rulesTree:
                                                    props.algorithm === "RandomForest" ? forest: treeExample}
                                title={props.algorithm}
                            />
                            {props.algorithm === "J48" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].j48Message1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].j48Message2}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="list" style={{textAlign: "justify"}}>
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link target="_blank" href=" https://doi.org/10.1007/BF00116251">
                                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText  >
                                                <Link target={"_blank"} href={"https://www.cs.waikato.ac.nz/ml/weka/book.html"}>
                                                    I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                            </CardContent>
                            }
                            {props.algorithm === "REPTree" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].repTreeMessage1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].repTreeMessage2}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link  target="_blank" href={"https://doi.org/10.1007/BF00116251"}>
                                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.&nbsp;
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link target="_blank" href={"https://www.cs.waikato.ac.nz/ml/weka/book.html"}>
                                                    I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.&nbsp;
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                            </CardContent>
                            }
                            {props.algorithm === "RandomTree" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].randomTreeMessage1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].randomTreeMessage2}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link target="_blank" href={"https://doi.org/10.1007/BF00116251"}>
                                                    J. R. Quinlan, "Induction of decision trees", Machine learning, 1(1):81–106, 1986.&nbsp;
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link target="_blank" href={"https://www.cs.waikato.ac.nz/ml/weka/book.html"}>
                                                    I. H. Witten, E. Frank, M. A. Hall, and C. J. Pal, "Data Mining: Practical machine learning tools and techniques", Morgan Kaufmann, 2016.&nbsp;
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                            </CardContent>
                            }
                            {props.algorithm === "FURIA" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].furiaMessage1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].furiaMessage2}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].furiaMessage3}
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                    <Link target="_blank" href={"https://doi.org/10.1007/s10618-009-0131-8"}>
                                        J. Huhn and E. Hullermeier, "FURIA: an algorithm for unordered fuzzy rule induction", Data Mining and Knowledge Discovery, 19(3):293–319, 2009.&nbsp;
                                    </Link>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                                <br/>
                            </CardContent>
                            }
                            {props.algorithm === "FuzzyHoeffdingDecisionTree" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].fuzzyHoeffdingDecisionTreeMessage1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].fuzzyHoeffdingDecisionTreeMessage2}
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                    <Link target="_blank" href={"https://doi.org/10.2991/eusflat-19.2019.102"}>
                                        R. Pecori, P. Ducange, F. Marcelloni, "Incremental learning of fuzzy decision trees for streaming data classification", in 11th Conference of the European Society for Fuzzy Logic and Technology (EUSFLAT), Atlantis Press, 2019.&nbsp;
                                    </Link>
                                            </ListItemText>
                                        </ListItem>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                Jose M. Alonso, Pietro Ducange, Riccardo Pecori, Raul Vilas, "Building Explainable Fuzzy Decision Trees with the ExpliClas Software", in IEEE International Conference on Fuzzy Systems (FUZZ-IEEE), Glasgow, Scotland, UK, pp. 1–8, 2020 &nbsp;
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                            </CardContent>
                            }
                            {props.algorithm === "RandomForest" &&
                            <CardContent>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].randomForestMessage1}
                                </Typography>
                                <br/>
                                <Typography variant="body" color="textSecondary" component="p" style={{textAlign: "justify"}}>
                                    {props.language.labels[props.language.id].randomForestMessage2}
                                    <List>
                                        <ListItem >
                                            <ListItemIcon>
                                                <FiberManualRecordIcon fontSize="small"/>
                                            </ListItemIcon>
                                            <ListItemText >
                                                <Link target="_blank" href={"https://doi.org/10.1023/A:1010933404324"}>
                                                    L. Breiman, "Random forests", Machine Learning, 45(1):5–32, 2001.&nbsp;
                                                </Link>
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Typography>
                            </CardContent>
                            }
                        </Card>
                    </Popup>)
                }
                {props.showConfig &&
                <Button
                    id={props.algorithm}
                    onClick={() => props.configuration(props.algorithm)}
                    size="small"
                    color="primary"
                    className={classes.buttonConfiguration}
                >
                    {props.language.labels[props.language.id].configuration}
                </Button>
                }
            </CardActions>
        </Card>
    );
}

AlgorithmCard.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AlgorithmCard);
